<!-- eslint-disable -->
<template>
  <transition name="crm-modal-fade">
    <div
      v-if="visible"
      class="crm-modal-backdrop"
      @mousedown.self="$emit('close')"
    >
      <div class="crm-modal-card crm-stage-manager">
        <!-- Header -->
        <div class="crm-modal-header">
          <div class="crm-modal-header__left">
            <div class="crm-modal-header__icon">
              <feather-icon icon="LayersIcon" size="18" />
            </div>
            <div>
              <h3 class="crm-modal-header__title">Configure Workflow Stages</h3>
              <p class="crm-modal-header__subtitle">Manage stages, WIP limits, and display order</p>
            </div>
          </div>
          <button class="crm-modal-close" @click="$emit('close')">
            <feather-icon icon="XIcon" size="18" />
          </button>
        </div>

        <!-- Body -->
        <div class="crm-modal-body">
          <p class="crm-stage-desc">
            Drag stages to reorder. Set WIP (Work In Progress) limits to control the maximum cards per stage. A WIP of 0 means unlimited.
          </p>

          <!-- Stages List -->
          <div class="crm-stage-list">
            <div
              class="crm-stage-row"
              v-for="(stage, index) in stages"
              :key="stage.id"
            >
              <div class="crm-stage-row__handle">
                <feather-icon icon="MenuIcon" size="14" />
              </div>

              <!-- Color picker -->
              <label class="crm-stage-row__color-wrap">
                <input
                  type="color"
                  class="crm-stage-row__color"
                  :value="stage.color"
                  @input="$emit('stage-update', { stageId: stage.id, field: 'color', value: $event.target.value })"
                />
                <span
                  class="crm-stage-row__color-swatch"
                  :style="{ backgroundColor: stage.color }"
                ></span>
              </label>

              <!-- Name -->
              <input
                type="text"
                class="crm-stage-row__name"
                :value="stage.name"
                @change="$emit('stage-update', { stageId: stage.id, field: 'name', value: $event.target.value })"
                placeholder="Stage name…"
              />

              <!-- WIP -->
              <div class="crm-stage-row__wip">
                <span class="crm-stage-row__wip-label">WIP</span>
                <input
                  type="number"
                  class="crm-stage-row__wip-input"
                  :value="stage.wipLimit || 0"
                  min="0"
                  max="99"
                  @change="$emit('stage-update', { stageId: stage.id, field: 'wipLimit', value: parseInt($event.target.value) || 0 })"
                />
              </div>

              <!-- Description -->
              <input
                type="text"
                class="crm-stage-row__desc"
                :value="stage.description || ''"
                @change="$emit('stage-update', { stageId: stage.id, field: 'description', value: $event.target.value })"
                placeholder="Description…"
              />

              <!-- Reorder buttons -->
              <div class="crm-stage-row__actions">
                <button
                  class="crm-stage-row__action-btn"
                  :disabled="index === 0"
                  @click="$emit('stage-reorder', { index, direction: 'up' })"
                  title="Move up"
                >
                  <feather-icon icon="ChevronUpIcon" size="14" />
                </button>
                <button
                  class="crm-stage-row__action-btn"
                  :disabled="index === stages.length - 1"
                  @click="$emit('stage-reorder', { index, direction: 'down' })"
                  title="Move down"
                >
                  <feather-icon icon="ChevronDownIcon" size="14" />
                </button>
                <button
                  class="crm-stage-row__action-btn crm-stage-row__action-btn--danger"
                  @click="$emit('stage-delete', stage.id)"
                  title="Delete stage"
                >
                  <feather-icon icon="Trash2Icon" size="14" />
                </button>
              </div>
            </div>
          </div>

          <!-- Add Stage -->
          <div class="crm-add-stage">
            <h5 class="crm-add-stage__title">Add New Stage</h5>
            <div class="crm-add-stage__form">
              <label class="crm-stage-row__color-wrap">
                <input
                  type="color"
                  class="crm-stage-row__color"
                  v-model="newStageColor"
                />
                <span
                  class="crm-stage-row__color-swatch"
                  :style="{ backgroundColor: newStageColor }"
                ></span>
              </label>
              <input
                type="text"
                class="crm-input crm-add-stage__input"
                v-model="newStageName"
                placeholder="Stage name…"
                @keyup.enter="addStage"
              />
              <button
                class="crm-btn crm-btn--primary crm-btn--sm"
                :disabled="!newStageName.trim()"
                @click="addStage"
              >
                <feather-icon icon="PlusIcon" size="14" />
                Add Stage
              </button>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="crm-modal-footer">
          <button class="crm-btn crm-btn--primary" @click="$emit('close')">
            Done
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  name: 'StageManagerModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newStageName: '',
      newStageColor: '#6366f1',
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.newStageName = ''
        this.newStageColor = '#6366f1'
      }
    },
  },
  methods: {
    addStage() {
      if (!this.newStageName.trim()) return
      this.$emit('stage-add', {
        name: this.newStageName.trim(),
        color: this.newStageColor,
      })
      this.newStageName = ''
      this.newStageColor = '#6366f1'
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #6366f1;
$primary-dark: #4f46e5;
$success: #10b981;
$warning: #f59e0b;
$danger: #f43f5e;
$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-300: #cbd5e1;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-900: #0f172a;

.crm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.crm-modal-card {
  background: #fff;
  border-radius: 16px;
  width: 580px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -12px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.crm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid $slate-100;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, $primary, $primary-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  &__title {
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: $slate-900;
    margin: 0;
  }

  &__subtitle {
    font-size: 12.5px;
    color: $slate-500;
    margin: 2px 0 0 0;
  }
}

.crm-modal-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: $slate-50;
  color: $slate-400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: $slate-100;
    color: $slate-600;
  }
}

.crm-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}

.crm-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid $slate-100;
  display: flex;
  justify-content: flex-end;
}

.crm-stage-desc {
  font-size: 13px;
  color: $slate-500;
  line-height: 1.5;
  margin: 0 0 20px 0;
  padding: 12px 14px;
  background: $slate-50;
  border-radius: 10px;
  border-left: 3px solid $primary;
}

.crm-stage-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
}

.crm-stage-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: $slate-50;
  border: 1.5px solid transparent;
  transition: all 0.2s;

  &:hover {
    background: #fff;
    border-color: $slate-200;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &__handle {
    color: $slate-300;
    cursor: grab;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__color-wrap {
    position: relative;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    cursor: pointer;
  }

  &__color {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
    width: 28px;
    height: 28px;
  }

  &__color-swatch {
    display: block;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 2px solid rgba(0, 0, 0, 0.08);
    transition: transform 0.15s;

    &:hover {
      transform: scale(1.1);
    }
  }

  &__name {
    font-family: 'Outfit', 'Inter', sans-serif;
    flex: 1;
    min-width: 0;
    border: 1.5px solid transparent;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 13.5px;
    font-weight: 600;
    color: $slate-700;
    background: transparent;
    outline: none;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
      border-color: $slate-200;
      background: #fff;
    }

    &:focus {
      border-color: $primary;
      background: #fff;
      box-shadow: 0 0 0 3px rgba($primary, 0.08);
    }
  }

  &__wip {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  &__wip-label {
    font-size: 10px;
    font-weight: 700;
    color: $slate-400;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &__wip-input {
    width: 42px;
    border: 1.5px solid $slate-200;
    border-radius: 6px;
    padding: 4px 6px;
    font-size: 12px;
    font-weight: 600;
    color: $slate-700;
    text-align: center;
    outline: none;
    background: #fff;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: border-color 0.2s;

    &:focus {
      border-color: $primary;
    }
  }

  &__desc {
    font-family: 'Outfit', 'Inter', sans-serif;
    width: 100px;
    border: 1.5px solid transparent;
    border-radius: 6px;
    padding: 6px 8px;
    font-size: 12px;
    color: $slate-500;
    background: transparent;
    outline: none;
    transition: border-color 0.2s, background 0.2s;
    flex-shrink: 0;

    &:hover {
      border-color: $slate-200;
      background: #fff;
    }

    &:focus {
      border-color: $primary;
      background: #fff;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
  }

  &__action-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: $slate-400;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;

    &:hover:not(:disabled) {
      background: $slate-100;
      color: $slate-600;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    &--danger {
      &:hover:not(:disabled) {
        background: rgba($danger, 0.08);
        color: $danger;
      }
    }
  }
}

.crm-add-stage {
  padding: 18px;
  background: $slate-50;
  border-radius: 12px;
  border: 1.5px dashed $slate-200;

  &__title {
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: $slate-600;
    margin: 0 0 12px 0;
  }

  &__form {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__input {
    flex: 1;
  }
}

.crm-input {
  font-family: 'Outfit', 'Inter', sans-serif;
  border: 1.5px solid $slate-200;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13.5px;
  color: $slate-700;
  background: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: $primary;
    box-shadow: 0 0 0 3px rgba($primary, 0.1);
  }
}

.crm-btn {
  font-family: 'Outfit', 'Inter', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &--primary {
    background: linear-gradient(135deg, $primary, $primary-dark);
    color: #fff;
    box-shadow: 0 2px 8px rgba($primary, 0.3);

    &:hover:not(:disabled) {
      box-shadow: 0 4px 14px rgba($primary, 0.4);
      transform: translateY(-1px);
    }
  }

  &--sm {
    padding: 7px 14px;
    font-size: 12.5px;
  }
}

.crm-modal-fade-enter-active,
.crm-modal-fade-leave-active {
  transition: opacity 0.25s ease;

  .crm-modal-card {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
  }
}

.crm-modal-fade-enter,
.crm-modal-fade-leave-to {
  opacity: 0;

  .crm-modal-card {
    transform: scale(0.95) translateY(10px);
    opacity: 0;
  }
}
</style>
